import React from "react";
import FormCard from "./FormCard";

/**
 * Live examples for the FormCard primitive — a titled section card used to group
 * related form fields.
 */
const FormCardExample: React.FC = () => {
	return (
		<div className="max-w-2xl space-y-6 p-6">
			<h3 className="text-lg font-semibold">FormCard Component Examples</h3>

			{/* Default — title + fields */}
			<FormCard title="Grunduppgifter" skipTranslation>
				<div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
					<input className="rounded-md border border-gray-300 px-3 py-2" placeholder="Kundnamn" />
					<input className="rounded-md border border-gray-300 px-3 py-2" placeholder="Telefon" />
				</div>
			</FormCard>

			{/* With a header action */}
			<FormCard
				title="Besöksadress"
				skipTranslation
				action={
					<button type="button" className="text-sm font-medium text-action hover:underline">
						Rensa
					</button>
				}
			>
				<input
					className="w-full rounded-md border border-gray-300 px-3 py-2"
					placeholder="Gatuadress"
				/>
			</FormCard>

			{/* Header-less card */}
			<FormCard>
				<p className="text-sm text-muted-foreground">
					A header-less card — just a padded, bordered surface around arbitrary content.
				</p>
			</FormCard>

			{/* Restyled via className */}
			<FormCard title="Custom styling" skipTranslation className="border-action/30 bg-action/5">
				<p className="text-sm text-muted-foreground">
					The container is restyled through the <code>className</code> prop (cn + tailwind-merge).
				</p>
			</FormCard>
		</div>
	);
};

export default FormCardExample;
